function parseIso(d: string): Date {
  const [y, m, day] = d.split('-').map(Number) as [number, number, number];
  return new Date(Date.UTC(y, m - 1, day));
}

export function formatIsoDate(d: Date): string {
  const y = d.getUTCFullYear();
  const m = String(d.getUTCMonth() + 1).padStart(2, '0');
  const day = String(d.getUTCDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}

export function mondayOf(isoDate: string): string {
  const d = parseIso(isoDate);
  const dow = d.getUTCDay(); // 0 = Sunday, 1 = Monday, ..., 6 = Saturday
  const offset = dow === 0 ? -6 : 1 - dow;
  d.setUTCDate(d.getUTCDate() + offset);
  return formatIsoDate(d);
}

export const weekIdOf = mondayOf;

export function addDays(isoDate: string, n: number): string {
  const d = parseIso(isoDate);
  d.setUTCDate(d.getUTCDate() + n);
  return formatIsoDate(d);
}

export function daysSince(fromIso: string, toIso: string): number {
  const ms = parseIso(toIso).getTime() - parseIso(fromIso).getTime();
  return Math.round(ms / 86400000);
}

export function todayIso(now: Date = new Date()): string {
  const y = now.getFullYear();
  const m = String(now.getMonth() + 1).padStart(2, '0');
  const day = String(now.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}

/**
 * Formats an ISO date (YYYY-MM-DD) as a human-readable short string.
 * Examples: "Apr 27, 2026" or "Mon Apr 27"
 */
export function formatDateShort(iso: string, opts: { weekday?: boolean; year?: boolean } = {}): string {
  const d = new Date(iso + 'T00:00:00Z');
  return d.toLocaleDateString(undefined, {
    timeZone: 'UTC',
    weekday: opts.weekday ? 'short' : undefined,
    month: 'short',
    day: 'numeric',
    year: opts.year ? 'numeric' : undefined,
  });
}

/**
 * Formats a week range as "Apr 27 – May 1". Takes the week's start ISO date.
 * Assumes a 5-day workweek (Mon–Fri). End = start + 4 days.
 */
export function formatWeekRange(startIso: string): string {
  const start = new Date(startIso + 'T00:00:00Z');
  const end = new Date(start);
  end.setUTCDate(end.getUTCDate() + 4);
  const startStr = start.toLocaleDateString(undefined, { timeZone: 'UTC', month: 'short', day: 'numeric' });
  const endStr = end.toLocaleDateString(undefined, { timeZone: 'UTC', month: 'short', day: 'numeric' });
  return `${startStr} – ${endStr}`;
}
